import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Button, Container, TextField, Select, MenuItem,
  FormControl, InputLabel, Box, Collapse, IconButton
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { getTimetable, saveTimetable, deleteTimetable } from "../services/timetable-service";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const TimetablePage = () => {
  const { competitionId } = useParams();
  const [competitionIdState] = useState(competitionId);

  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);

  const [newDurata, setNewDurata] = useState("");
  const [newTipo, setNewTipo] = useState("gara");
  const [durataError, setDurataError] = useState(false);

  const [startTime, setStartTime] = useState("");  // Orario di inizio competizione
  const [breakTime, setBreakTime] = useState("");  // Pausa tra esibizioni
  const [startTimeError, setStartTimeError] = useState(false);
  const [breakTimeError, setBreakTimeError] = useState(false);


  const loadTimetable = async () => {
    try {
      setLoading(true);
      const timetableRemote = await getTimetable(competitionIdState);

      setStartTime(timetableRemote.startTime);
      setBreakTime(timetableRemote.breakTime);

      timetableRemote.timetableRows.sort((a, b) => a.position - b.position);

      const map = new Map();
      timetableRemote.timetableRows.forEach(r => {
        let key;
        if (r.tipo === "gara") {
          key = r.disciplina + "|" + r.categoria + "|" + r.classe + "|" + r.unita + "|" + r.tipo;
        } else {
          key = r.id + "|" + r.tipo;
        }

        if (!map.has(key)) map.set(key, []);
        map.get(key).push(r);
      });

      const loadedBlocks = Array.from(map.entries()).map(([key, rows]) => ({
        key,
        open: false,
        rows
      }));

      setBlocks(loadedBlocks);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  // --- Caricamento dati dal backend ---
  useEffect(() => {
    loadTimetable();
  }, [competitionIdState]);

  if (loading) return <div>Caricamento...</div>;

  const isValidDuration = (value) => {
    return true;
    /^([0-1]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(value);
  } 
  const isFormValid = () => newDurata && isValidDuration(newDurata);

  const isValidBreakTime = (value) => !isNaN(value) && parseInt(value) >= 0;

  // --- Aggiunta pausa/premiazione ---
  const addSpecialBlock = () => {
    if (!isFormValid()) return;
    const newRow = {
      id: "tmp_" + Date.now(),
      disciplina: "",
      categoria: "",
      classe: "",
      unita: "",
      durata: newDurata || "00:05",
      tipo: newTipo,
      athletes: [],
      number: "",
      association: "",
      region: "",
      choreography: "",
      position: blocks.reduce((max, block) => Math.max(max, block.rows.length), 0) // posiziona alla fine
    };
    const newBlock = {
      key: `special_${newRow.id}`,
      open: true,
      rows: [newRow]
    };
    setBlocks(prev => [...prev, newBlock]);
    setNewDurata("");
    setNewTipo("pausa");
    setDurataError(false);
  };

  // --- Drag & Drop blocchi ---
  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    // Riordina i blocchi
    const reordered = Array.from(blocks);
    const [removed] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, removed);

    // Ricomputa le posizioni delle righe
    let pos = 0;
    const updatedBlocks = reordered.map(block => {
      const newRows = block.rows.map(row => ({ ...row, position: pos++ }));
      return { ...block, rows: newRows };
    });

    setBlocks(updatedBlocks);
  };

  const moveRow = (blockKey, rowId, direction) => {
    setBlocks(prevBlocks => {
      let globalPos = 0;

      return prevBlocks.map(block => {

        // Se NON è il blocco modificato, aggiorno comunque le position globali
        if (block.key !== blockKey) {
          const updatedRows = block.rows.map(row => ({
            ...row,
            position: globalPos++
          }));
          return { ...block, rows: updatedRows };
        }

        // Blocco modificato
        const newRows = [...block.rows];
        const index = newRows.findIndex(r => r.id === rowId);
        if (index === -1) return block;

        const target = direction === "up" ? index - 1 : index + 1;
        if (target < 0 || target >= newRows.length) return block;

        const [removed] = newRows.splice(index, 1);
        newRows.splice(target, 0, removed);

        // 🔥 ricalcolo posizione globale
        const updatedRows = newRows.map(row => ({
          ...row,
          position: globalPos++
        }));

        return { ...block, rows: updatedRows };
      });
    });
  };

  // --- Aggiornamento durata ---
  const updateDurata = (blockKey, rowId, value) => {
    debugger;
    if (value === "" || isValidDuration(value)) {
      setBlocks(prevBlocks =>
        prevBlocks.map(block => {
          if (block.key !== blockKey) return block;
          const newRows = block.rows.map(r => r.id === rowId ? { ...r, durata: value } : r);
          return { ...block, rows: newRows };
        })
      );
    }
  };

  // --- Toggle apertura blocco ---
  const toggleBlock = (key) => {
    setBlocks(prev => prev.map(b => b.key === key ? { ...b, open: !b.open } : b));
  };



  // --- Salvataggio ---
  const handleSave = async () => {
    try {
      const payload = {
        competitionId: competitionIdState,
        startTime: startTime,  // Orario di inizio competizione
        breakTime: breakTime,  // Pausa tra le esibizioni
        timetableRows: blocks.flatMap(b => b.rows),  // Gli altri dati della tabella
      };
      await saveTimetable(competitionIdState, payload);

      // RICARICA DATI DAL DB
      await loadTimetable();

      alert("Timetable salvato con successo!");
    } catch (err) {
      console.error(err);
      alert("Errore nel salvataggio!");
    }
  };

  // --- Eliminazione totale ---
  const handleDeleteAll = async () => {
    if (!window.confirm("Sei sicuro di voler eliminare tutto il timetable?")) return;
    try {
      await deleteTimetable(competitionIdState);
      setBlocks([]);
      alert("Timetable eliminato!");
    } catch (err) {
      console.error(err);
      alert("Errore nell'eliminazione!");
    }
  };

  return (
    <Container>
      <h2>Orario Gara</h2>
      <Box sx={{ mb: 2, display: "flex", gap: 2 }}>
        <Link to={`/competition/${competitionIdState}`} style={{ textDecoration: "none" }}>
          <Button variant="contained">Torna alla Competizione</Button>
        </Link>
        <Button variant="contained" color="success" onClick={handleSave}>Salva</Button>
        <Button variant="outlined" color="error" onClick={handleDeleteAll}>Elimina tutto</Button>
      </Box>

      <Box sx={{ mb: 3, display: "flex", gap: 2, flexWrap: "wrap" }}>
        <TextField
          label="Orario Inizio Competizione (HH:MM:ss)"
          value={startTime}
          error={startTimeError}
          helperText={startTimeError ? "Formato HH:MM:ss richiesto" : ""}
          onChange={(e) => {
            setStartTime(e.target.value);
            setStartTimeError(e.target.value && !isValidDuration(e.target.value));
          }}
        />
        <TextField
          label="Pausa tra Esibizioni (secondi)"
          value={breakTime}
          error={breakTimeError}
          helperText={breakTimeError ? "Deve essere un numero valido" : ""}
          onChange={(e) => {
            setBreakTime(e.target.value);
            setBreakTimeError(e.target.value && isNaN(e.target.value));
          }}
        />
      </Box>

      {/* Form aggiunta pausa/premiazione */}
      <Box sx={{ mb: 3, display: "flex", gap: 2, flexWrap: "wrap" }}>
        <TextField
          label="Durata (HH:MM:ss)"
          value={newDurata}
          error={durataError}
          helperText={durataError ? "Formato HH:MM:ss richiesto" : ""}
          onChange={e => {
            setNewDurata(e.target.value);
            setDurataError(e.target.value && !(e.target.value));
          }}
        />
        <FormControl sx={{ minWidth: 150 }}>
          <InputLabel>Tipo</InputLabel>
          <Select value={newTipo} label="Tipo" onChange={e => setNewTipo(e.target.value)}>
            <MenuItem value="Pausa">Pausa Tecnica</MenuItem>
            <MenuItem value="Premiazione">Premiazione</MenuItem>
            <MenuItem value="Pranzo">Pausa Pranzo</MenuItem>
          </Select>
        </FormControl>
        <Button variant="contained" color="secondary" onClick={addSpecialBlock} disabled={!isFormValid()}>
          Aggiungi
        </Button>
      </Box>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="blocks">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {blocks.map((block, blockIndex) => (
                <Draggable key={block.key} draggableId={block.key} index={blockIndex}>
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.draggableProps}>
                      <Box sx={{ mb: 2, border: '1px solid #ccc', borderRadius: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#f0f0f0', px: 2 }}>
                          <IconButton onClick={() => toggleBlock(block.key)}>
                            {block.open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </IconButton>
                          <span {...provided.dragHandleProps} style={{ cursor: 'grab', fontWeight: 'bold' }}>
                            {block.rows[0].tipo === "gara"
                              ? `${block.rows[0].disciplina} - ${block.rows[0].classe} ${block.rows[0].categoria} ${block.rows[0].unita}`
                              : block.rows[0].tipo}
                          </span>
                        </Box>
                        <Collapse in={block.open}>
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Numero</TableCell>
                                  <TableCell>Atleti</TableCell>
                                  <TableCell>Coreografia</TableCell>
                                  <TableCell>Associazione</TableCell>
                                  <TableCell>Regione</TableCell>
                                  <TableCell>Durata</TableCell>
                                  {block.rows[0].tipo === "gara" && <TableCell>Azione</TableCell>}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {block.rows.map(row => (
                                  <TableRow key={row.id}>
                                    <TableCell>{row.number}</TableCell>
                                    <TableCell>
                                      {Array.isArray(row.athletes) && row.athletes.length > 0
                                        ? row.athletes
                                            .slice() // crea copia
                                            .sort((a, b) => a.localeCompare(b))
                                            .join(", ")
                                        : ""}
                                    </TableCell>
                                    <TableCell>{row.choreography}</TableCell>
                                    <TableCell>{row.association}</TableCell>
                                    <TableCell>{row.region}</TableCell>
                                    <TableCell>
                                      <TextField
                                        value={row.durata}
                                        onChange={e => updateDurata(block.key, row.id, e.target.value)}
                                        size="small"
                                        sx={{ width: 80 }}
                                        error={row.durata && !isValidDuration(row.durata)}
                                        helperText={row.durata && !isValidDuration(row.durata) ? "HH:MM:ss richiesto" : ""}
                                      />
                                    </TableCell>
                                    {block.rows[0].tipo === "gara" && (
                                      <TableCell>
                                        <Button size="small" onClick={() => moveRow(block.key, row.id, "up")}>Su</Button>
                                        <Button size="small" onClick={() => moveRow(block.key, row.id, "down")}>Giù</Button>
                                      </TableCell>
                                    )}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Collapse>
                      </Box>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Container>
  );
};

export default TimetablePage;

